import React from "react";
import { Row, Col, Alert } from "react-bootstrap";
import "./Restringido.css";


/**
 * Muestra un aviso para indicar que la información no se puede mostrar.
 */
export default class Restringido extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			message: props.message,
		};
	}

	render() {
		return (
			<Row>
				<Col xs={8} xsPush={2} md={6} mdPush={3}>
					<Alert bsStyle="warning">
						<center>
							<i className={`fa fa-2x fa-exclamation-triangle`} />
							<b>{this.state.message}</b>
						</center>
					</Alert>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/restringido/Restringido.js